export { attachmentVariables as attachmentDescriptionVariables } from './attachmentVariables';
